import 'tinymce/skins/ui/oxide/skin.css';

$(document).ready(function() {
	const textareas = $('textarea[data-frm-editor="tinymce"]').toArray();

	if (!textareas.length) {
		return;
	}

	import('tinymce/tinymce').then((tinymceModule) => {
		const tinymce = tinymceModule.default;

		window.tinymce = tinymce;
		window.tinyMCE = tinymce;

		return Promise.all([
			import('tinymce/icons/default'),
			import('tinymce/themes/silver'),
			import('tinymce/models/dom'),
			import('tinymce/plugins/link'),
			import('tinymce/plugins/lists'),
			import('tinymce/plugins/autoresize')
		]).then(() => {
			textareas.forEach((textarea) => {
				if (textarea.dataset.frmEditorInitialized === 'true') {
					return;
				}

				textarea.dataset.frmEditorInitialized = 'true';

				tinymce.init({
					target: textarea,
					license_key: 'gpl',
					skin: false,
					content_css: false,
					menubar: false,
					branding: false,
					statusbar: false,
					promotion: false,
					plugins: 'link lists autoresize',
					toolbar: textarea.dataset.toolbar || 'bold italic | bullist numlist | link | undo redo',
					min_height: 220,
					autoresize_bottom_margin: 12,
					content_style: `
						@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');

						body {
							background: #f3f3f3;
							color: #0C3455;
							font-family: Inter, Arial, sans-serif;
							font-size: 16px;
							font-weight: 500;
							line-height: 1.5;
							margin: 11px 16px;
						}

						p {
							font-family: inherit;
							font-size: inherit;
							font-weight: inherit;
							line-height: inherit;
							margin: 0 0 12px;
						}

						ul,
						ol {
							margin: 0 0 12px;
							padding-left: 24px;
						}

						li {
							font-family: inherit;
							font-size: inherit;
							font-weight: inherit;
							line-height: inherit;
							margin: 0 0 8px;
						}

						a {
							color: #0C3455;
							text-decoration: underline;
						}
					`,
					setup(editor) {
						editor.on('change keyup undo redo', function() {
							editor.save();
							$(textarea).trigger('change');
						});
					}
				});
			});
		});
	});
});
